import AOS from 'aos'
import 'aos/dist/aos.css'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:mounted', () => {
        AOS.init({
            offset: 60,
        })
    })

    nuxtApp.hook('page:finish', () => {
        setTimeout(() => {
            AOS.refreshHard()
        }, 100)
    })
})
